import { API_URL } from "../Config";
import { PageResult } from "../Pagination";

export interface IIncidentCorrectiveAndPreventativeAction {
  incidentcorrectivepreventativemeasureid: string;
  actiontype: string;
  action: string;
  incidentid: string;
  actiondate: string;
}

export interface IIncidentCorrectiveAndPreventativeActionsList
  extends PageResult {
  list: IIncidentCorrectiveAndPreventativeAction[];
}

export const GetIncidentCorrectiveAndPreventativeActionsFetchUrl = (
  incidentId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;
  var filterParams = "";
  if (searchText && searchText.length > 0) {
    filterParams += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/Incident/incidentcorrectivemeasureslist?incident_id=${incidentId}${filterParams}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/incident-corrective-and-preventative-actions`;
  }

  return url;
};
